import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@clerk/react";
import Shell from "@/components/Shell";
import { makeApi } from "@/lib/api";
import PlanEditor from "@/components/plans/PlanEditor";

export default function AdminPlans() {
  const { getToken } = useAuth();
  const api = useMemo(() => makeApi(getToken), [getToken]);
  const [plans, setPlans] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    api.get("/admin/plans").then(({ data }) => setPlans(data.plans))
      .catch((e) => setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Could not load plans."));
  }, [api]);
  const onSaved = (p) => setPlans((ps) => ps.map((x) => (x.lookup_key === p.lookup_key ? p : x)));

  return (
    <Shell>
      <div className="mb-8">
        <div className="font-mono-label text-xs text-[#FFD600] mb-2">OWNER · PLANS</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl leading-none" data-testid="plans-title">Plans & Pricing.</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl text-sm sm:text-base">
          Edit what clients see on the Pick a Plan page. Changes go live as soon as you save. Clients already subscribed keep the price they signed up at.
        </p>
      </div>
      {error && <div className="brutal-border border-[#F87171] text-sm text-[#F87171] p-3" data-testid="plans-error">{error}</div>}
      {!plans && !error && <div className="font-mono-label text-xs text-muted-foreground">LOADING…</div>}
      <div className="grid lg:grid-cols-2 gap-6">
        {plans?.map((p) => <PlanEditor key={p.lookup_key} api={api} plan={p} onSaved={onSaved} />)}
      </div>
    </Shell>
  );
}
